import { FeatureFlagKey } from "@redotech/feature-flags-model/keys";
import { useRequiredContext } from "@redotech/react-util/context";
import { useLoad } from "@redotech/react-util/load";
import { RedoMarketingRpcClientContext } from "@redotech/redo-merchant-app-common/marketing-rpc-client-provider";

/**
 * Temporary bridge while Concierge replaces the unreleased Marketing Agent v2
 * experience. The flag name is legacy, but the behavior here is specifically:
 * use the shopper-agent Playbook as Concierge's configuration surface.
 */
export function useShopperAgentPlaybookConfigEnabled(): boolean {
  const marketingRpcClient = useRequiredContext(RedoMarketingRpcClientContext);

  const flagLoad = useLoad(
    (signal) =>
      marketingRpcClient.getBooleanFeatureFlag(
        { key: FeatureFlagKey.NEW_MARKETING_AGENT_ONBOARDING },
        { signal },
      ),
    [marketingRpcClient],
  );

  return flagLoad.value?.enabled ?? false;
}
